import { put, take, fork, call } from 'redux-saga/effects'
import { courseRemoveCardService } from 'src/api/card'

import { COURSE_REMOVE_CARD } from 'src/reducers/card/type'
import generalSaga from '../general'

import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'
/**
 *
 * @param {*} payload
 */
function* courseRemoveCardFlow(payload) {
  try {
    const { courseId, cardId, callback } = payload

    yield call(courseRemoveCardService, cardId, courseId)

    yield put(operationSuccess())
    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseRemoveCardWatcher() {
  while (true) {
    const action = yield take(COURSE_REMOVE_CARD)
    const { payload } = action
    yield fork(generalSaga, courseRemoveCardFlow, payload)
  }
}
